if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const currencyRate = Shopify.currency.rate ? Number(Shopify.currency.rate) : 1;
      const cartTotal = Number(this.getAttribute('data-cart-total'));

      let tiers;
      if ( this.hasAttribute('data-tiers') ) {
        tiers = JSON.parse(this.getAttribute('data-tiers')).map(tier => {
          // Reward amount is static per tier (unlike remaining_amount, which depends
          // on the live cart total) - resolve its {{ reward_amount }} token here, once,
          // via the same money formatter so it renders with the real currency SVG
          // instead of the old hardcoded "AED" text.
          const rewardMoney = tier.reward ? this._formatMoney(Math.round(tier.reward * currencyRate), KROWN.settings.shop_money_format) : '';
          return {
            ...tier,
            threshold: Math.round(tier.threshold * currencyRate),
            remaining_html: tier.remaining_html.replace('{{ reward_amount }}', rewardMoney),
            reached_html: tier.reached_html.replace('{{ reward_amount }}', rewardMoney),
            goal_html: (tier.goal_html || '').replace('{{ reward_amount }}', rewardMoney),
            earned_html: (tier.earned_html || '').replace('{{ reward_amount }}', rewardMoney)
          };
        });
      } else {
        // Backwards-compatible single-threshold mode for older markup.
        tiers = [{
          threshold: Math.round(Number(this.getAttribute('data-free-shipping')) * currencyRate),
          remaining_html: window.KROWN.settings.locales.shipping_notice_remaining_to_free,
          reached_html: window.KROWN.settings.locales.shipping_notice_eligible_for_free
        }];
      }

      const nextTier = tiers.find(tier => cartTotal < tier.threshold);
      const crossedTiers = tiers.filter(tier => cartTotal >= tier.threshold);
      const lastCrossedTier = crossedTiers[crossedTiers.length - 1];
      const textEl = this.querySelector('[data-js-free-shipping-text]');
      const congratsEl = this.querySelector('[data-js-free-shipping-congrats]');

      let cartSliderWidth = 100;
      let congratsHTML = '';
      let remainingHTML = '';

      if ( nextTier ) {
        const remaining = nextTier.threshold - cartTotal;
        remainingHTML = nextTier.remaining_html.replace('{{ remaining_amount }}', this._formatMoney(remaining, KROWN.settings.shop_money_format));
        if ( lastCrossedTier ) {
          congratsHTML = lastCrossedTier.reached_html;
        }
        // Progress within THIS tier's own segment (from the last crossed
        // threshold, or 0 if none yet, up to the next one) - not cartTotal
        // against the next threshold directly, which measures every tier
        // as a fraction of the same final number and so never actually
        // completes a segment on its way to the last one, just keeps
        // creeping up. This way the bar reaches 100% exactly as each tier
        // is crossed, matching the reset-and-refill jump component-
        // product-form.js plays for that moment (search
        // _animateShippingBarSteps).
        const segmentStart = lastCrossedTier ? lastCrossedTier.threshold : 0;
        const segmentSize = nextTier.threshold - segmentStart;
        cartSliderWidth = (cartTotal - segmentStart) * 100 / segmentSize;
      } else {
        congratsHTML = tiers[tiers.length - 1].reached_html;
      }

      // Labels on the bar: what is already unlocked (left, only once at least one
      // tier is crossed but not all) and what the next tier gives (right).
      const goalEl = this.querySelector('[data-js-free-shipping-goal]');
      const earnedEl = this.querySelector('[data-js-free-shipping-earned]');
      if ( goalEl ) goalEl.innerHTML = nextTier ? ( nextTier.goal_html || '' ) : '';
      if ( earnedEl ) earnedEl.innerHTML = ( nextTier && lastCrossedTier ) ? ( lastCrossedTier.earned_html || '' ) : '';
      // Pins at both ends of the bar: the start one is "won" once a tier is already
      // crossed, the end one once every tier is (no next tier left).
      this.classList.toggle('has-earned', !! ( nextTier && lastCrossedTier ) || ! nextTier );
      this.classList.toggle('is-complete', ! nextTier );
      const labelsEl = this.querySelector('.cart-notice__labels');
      if ( labelsEl ) labelsEl.hidden = ! ( ( goalEl && goalEl.innerHTML ) || ( earnedEl && earnedEl.innerHTML ) );

      if ( congratsEl ) {
        // Congratulations render on their own line above the remaining-progress text.
        congratsEl.innerHTML = congratsHTML;
        textEl.innerHTML = remainingHTML;
      } else {
        // Older markup without a dedicated congrats element: fall back to one combined line.
        textEl.innerHTML = congratsHTML && remainingHTML ? `${congratsHTML} ${remainingHTML}` : (congratsHTML || remainingHTML);
      }

			if ( this.querySelector('[data-js-free-shipping-slider]') ) {
				this.querySelector('[data-js-free-shipping-slider]').style.width = `${cartSliderWidth}%`;
			}

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}